import { Box, BoxProps, Typography } from '@mui/material'
import { SVGProps } from 'react'

interface NotificationProps extends BoxProps {
  message: React.ReactNode
}

const InfoWarning = (props: SVGProps<any>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.3986 4.3986C6.34317 2.45406 9.0317 1.25 12 1.25C14.9683 1.25 17.6568 2.45406 19.6014 4.3986C21.5459 6.34317 22.75 9.0317 22.75 12C22.75 14.9683 21.5459 17.6568 19.6014 19.6014C17.6568 21.5459 14.9683 22.75 12 22.75C9.0317 22.75 6.34317 21.5459 4.3986 19.6014C2.45406 17.6568 1.25 14.9683 1.25 12C1.25 9.0317 2.45407 6.34316 4.3986 4.3986ZM12 2.75C9.4455 2.75 7.13403 3.78452 5.45926 5.45926C3.78451 7.13404 2.75 9.4455 2.75 12C2.75 14.5545 3.78452 16.866 5.45926 18.5407C7.13403 20.2155 9.4455 21.25 12 21.25C14.5545 21.25 16.866 20.2155 18.5407 18.5407C20.2155 16.866 21.25 14.5545 21.25 12C21.25 9.4455 20.2155 7.13403 18.5407 5.45926C16.866 3.78452 14.5545 2.75 12 2.75Z"
      fill="#333333"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 18C12.6904 18 13.25 17.4404 13.25 16.75C13.25 16.0597 12.6904 15.5 12 15.5C11.3097 15.5 10.75 16.0597 10.75 16.75C10.75 17.4404 11.3097 18 12 18Z"
      fill="#333333"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.9998 14.25C12.4664 14.25 12.9298 13.9142 12.9298 13.5V6.75C12.9298 6.33579 12.4664 6 11.9998 6C11.5333 6 11.0698 6.33579 11.0698 6.75C11.0698 6.75 11.0698 13.245 11.0698 13.5C11.0698 13.92 11.5333 14.25 11.9998 14.25Z"
      fill="#333333"
    />
  </svg>
)

export function Notification({
  children,
  message,
  ...rest
}: NotificationProps) {
  return (
    <Box
      {...rest}
      sx={{
        padding: '12px',
        backgroundColor: '#EAEEF8',
        borderRadius: '4px',
        ...rest.sx,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          gap: '8px',
        }}
      >
        <InfoWarning
          style={{
            flex: '0 0 24px',
          }}
        />
        <Typography
          sx={{
            fontWeight: 400,
            fontSize: '14px',
            lineHeight: '24px',
            letterSpacing: '0',
            verticalAlign: 'middle',
            color: '#333333',
          }}
        >
          {message}
        </Typography>
      </Box>
      {children}
    </Box>
  )
}
